import { isLoginSuccess } from 'helpers/auth';
import { getDummyTracks } from 'data/dummy-dashboard';

const initialState = {
  pending: null,
  items: [],
  chosenItems: []
};

export default function tracks(state = initialState, action) {
  switch (action.type) {
    case 'GET_USER_COMPLETE':
      if (action.payload.response.login === null) {
        return {
          pending: false,
          items: getDummyTracks(),
          chosenItems: []
        };
      }
      return state;
    case 'POST_USER_LOGIN_COMPLETE':
      if (!isLoginSuccess(action.payload.response)) {
        return state;
      }
      return {
        pending: true,
        items: [],
        chosenItems: []
      };
    case 'POST_USER_LOGOUT_COMPLETE':
      return {
        pending: false,
        items: getDummyTracks(),
        chosenItems: []
      };
    case 'GET_TRACKS_START':
      return { ...state,
        ...{ pending: true }
      };
    case 'GET_TRACKS_COMPLETE':
      if (!Array.isArray(action.payload.response)) {
        return state;
      }
      return {
        ...state, ...{
          pending: false,
          items: action.payload.response
        }
      };
    case 'DELETE_TRACK_COMPLETE': {
      let deletedIndex = state.items.findIndex((item) => {
        return item.id === action.payload.request.id;
      });

      if (deletedIndex !== null) {
        state.items.splice(deletedIndex, 1);
      }

      deletedIndex = state.chosenItems.findIndex((item) => {
        return item.id === action.payload.request.id
      });

      if (deletedIndex !== null) {
        state.chosenItems.splice(deletedIndex, 1);
      }

      return { ...state };
    }
    case 'PUT_TRACK_PATH_COMPLETE': {
      let movedIndex = state.items.findIndex((item) => {
        return item.id === action.payload.request.id;
      });

      if (movedIndex !== null) {
        state.items[movedIndex].parentId = action.payload.request.parentId
      }

      return { ...state };
    }
    case 'TRACK_UPLOADING_COMPLETE':
      if (typeof action.payload.item === 'object') {

        let uploadedIndex = state.items.findIndex((item) => {
          return item.id === action.payload.item.id;
        });

        if (uploadedIndex === -1) {
          state.items.push(action.payload.item);
          return { ...state };
        }
      }

      return state;
    case 'TRACKS_CHOISE_TOGGLE':
      let chosenIndex = state.items.findIndex((item) => {
        return item.id === action.payload.id;
      });

      let chosenItemsIndex = state.chosenItems.findIndex((item) => {
        return item.id === action.payload.id;
      });

      if ((chosenItemsIndex === -1)
         && (action.payload.checkstate === false)
      ) {
        return state;
      }

      if ((chosenItemsIndex >= 0)
         && (action.payload.checkstate === true)
      ) {
        return state;
      }

      if ((chosenItemsIndex === -1)
         && (action.payload.checkstate === true)
      ) {
        state.chosenItems.push(state.items[chosenIndex]);
        return { ...state };
      }

      if ((chosenItemsIndex >= 0)
         && (action.payload.checkstate === false)
      ) {
        state.chosenItems.splice(chosenItemsIndex, 1);
        return { ...state };
      }

      return state;
    case 'TRACKS_UNCHOOSE_ALL':
      state.chosenItems = [];
      return { ...state };
    default:
      return state;
  }
}
